import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';
import { parse, stringify } from '../../utils/UrlUtil';
import { withAccount } from '../../components/AccountContext';
import { intlShape } from '../../components/prop-types';

const i18n = defineMessages({
  newSuperLink: { id: 'superlink.add', defaultMessage: 'Add SuperLink' },
});

class SuperlinkListHeader extends Component {
  constructor(props) {
    super(props);
    this.onQueryVariableChange = this.onQueryVariableChange.bind(this);
    this.onChangeQueryText = this.onChangeQueryText.bind(this);
    this.navigateToCreation = this.navigateToCreation.bind(this);

    // extract initial state from URL
    const { location } = this.props;
    const params = parse(location.search);

    // Make sure initial state has some nice defaults
    this.state = {
      filter: Object.assign({}, params.filter),
    };
  }

  /**
   * Get old URL and:
   * - parse query params
   * - merge new param values
   * - stringify query params
   * - push new url
   */
  onQueryVariableChange() {
    const { location, history } = this.props;
    const { filter } = this.state;

    const params = parse(location.search);

    // build the filter
    const newFilter = {
      ...params.filter,
      ...filter,
    };

    // handle edge case for respondentType = ALL.
    if (newFilter.respondentType === 'ALL') {
      newFilter.respondentType = undefined;
    }

    const search = stringify({
      ...params,
      filter: newFilter,
    });

    // update url with the new search, keep the rest of the values
    history.push({
      ...location,
      search,
    });
  }

  /**
   * Update the filter Query.
   */
  onChangeQueryText(event) {
    const { filter } = this.state;
    this.setState({
      filter: {
        ...filter,
        query: event.currentTarget.value,
      },
    });
  }

  navigateToCreation() {
    const { history, currentAccount } = this.props;
    const redirectLink = `/accounts/${currentAccount}/super-links/new`;
    history.push(redirectLink);
  }

  render() {
    const {
      intl: { formatMessage },
    } = this.props;
    const { filter } = this.state;
    const createNewSuperLink = formatMessage(i18n.newSuperLink);
    return (
      <React.Fragment>
        <div className="p-grid">
          <div className="p-col p-md-6">
            <div className="p-inputgroup">
              <InputText
                value={filter.query}
                onChange={this.onChangeQueryText}
                onKeyPress={(event) => {
                  if (event.key === 'Enter') {
                    this.onQueryVariableChange();
                  }
                }}
              />
              <Button
                icon="pi pi-search"
                // For search we have a search button.
                // The state is already updated. We just upate the url
                onClick={this.onQueryVariableChange}
              />
            </div>
          </div>
          <div className="p-col p-md-6 align-right">
            <Button icon="pi pi-plus" type="button" label={createNewSuperLink} onClick={this.navigateToCreation} />
          </div>
        </div>
      </React.Fragment>
    );
  }
}

SuperlinkListHeader.propTypes = {
  location: PropTypes.objectOf(PropTypes.any).isRequired,
  history: PropTypes.objectOf(PropTypes.any).isRequired,
  currentAccount: PropTypes.string.isRequired,
  intl: intlShape.isRequired,
};

export default withAccount(withRouter(injectIntl(SuperlinkListHeader)));
